import { Box, MenuItem, Typography } from '@mui/material'
import { HTMLAttributes } from 'react'

import { BoxWithLogo } from 'components/Box'
import { SelectOption, SelectProps } from 'components/Select'

type OptionToMenuItemProps<T> = Pick<SelectProps<T>, 'disabledOptions' | 'labelColor' | 'size'> &
  SelectOption<T> & {
    autocompleteOptionProps?: HTMLAttributes<HTMLLIElement>
  }

export const optionToMenuItem = <T,>({
  autocompleteOptionProps,
  disabledOptions,
  endAdornment,
  label,
  labelColor,
  logo,
  size,
  value,
}: OptionToMenuItemProps<T>): React.JSX.Element => {
  const isDisabled: boolean = disabledOptions?.includes(value) ?? false

  const cypressProps = {
    'data-cy': `select-option-${value}`,
  }

  const content: React.JSX.Element = (
    <BoxWithLogo
      logo={{
        size: 'small',
        svg: logo,
      }}
    >
      <Typography
        data-cy={`select-option-label-${label}`}
        sx={{ color: labelColor?.({ value: value as T }) }}
        variant={size === 'small' ? 'body2' : 'body1'}
      >
        {label}
      </Typography>

      {endAdornment && <Box sx={{ mx: 1 }}>{endAdornment}</Box>}
    </BoxWithLogo>
  )

  if (autocompleteOptionProps !== undefined) {
    return (
      <li
        {...autocompleteOptionProps}
        {...cypressProps}
        aria-disabled={isDisabled || undefined}
        key={value}
      >
        {content}
      </li>
    )
  } else {
    return (
      <MenuItem
        {...cypressProps}
        disabled={isDisabled}
        key={value}
        value={value}
      >
        {content}
      </MenuItem>
    )
  }
}
